module.exports = __webpack_public_path__ + "static/media/logoUpdated.84e89980.svg";